var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7969 2.90135C15.4977 3.14758 16 3.81513 16 4.6V12.6C16 14.4778 14.4778 16 12.6 16H4.6C3.81513 16 3.14758 15.4977 2.90135 14.7969L4.57917 14.7996L12.6 14.8C13.815 14.8 14.8 13.815 14.8 12.6V4.6L14.7968 4.55922L14.7969 2.90135ZM12.1975 0C13.1916 0 13.9975 0.805887 13.9975 1.8V12.1975C13.9975 13.1916 13.1916 13.9975 12.1975 13.9975H1.8C0.805887 13.9975 0 13.1916 0 12.1975V1.8C0 0.805887 0.805887 0 1.8 0H12.1975ZM12.1975 1.2H1.8C1.46863 1.2 1.2 1.46863 1.2 1.8V12.1975C1.2 12.5288 1.46863 12.7975 1.8 12.7975H12.1975C12.5288 12.7975 12.7975 12.5288 12.7975 12.1975V1.8C12.7975 1.46863 12.5288 1.2 12.1975 1.2Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIn);
export default __webpack_public_path__ + "static/media/select-in.70858c05fe5542d094e2ea6d14c7a179.svg";
export { ForwardRef as ReactComponent };